import React, { useState, useEffect } from 'react';
import { Settings, Bell, Lock, User } from 'lucide-react';
import { UserProfile } from '../../settings/UserProfile';
import { useLocation } from 'react-router-dom';

export function HotelSettings() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('user');

  useEffect(() => {
    // Check if we should show the user profile tab
    if (location.state?.settingsTab === 'user') {
      setActiveTab('user');
    }
  }, [location.state]);

  const tabs = [
    { id: 'user', label: 'User Profile', icon: User },
    { id: 'notifications', label: 'Notifications', icon: Bell },
    { id: 'security', label: 'Security', icon: Lock },
  ];

  return (
    <div className="extranet-container">
      <div className="extranet-container-header">
        <div className="flex items-center">
          <Settings className="h-6 w-6 text-blue-500 mr-2" />
          <h2 className="text-xl font-bold text-gray-900">Settings</h2>
        </div>
      </div>

      <div className="extranet-container-body">
        {/* Tabs */}
        <div className="border-b border-gray-300">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    flex items-center py-4 px-1 border-b-2 font-medium text-sm
                    ${activeTab === tab.id
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }
                  `}
                >
                  <Icon className="h-5 w-5 mr-2" />
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Content */}
        <div className="mt-6">
          {activeTab === 'user' && <UserProfile />}

          {activeTab === 'notifications' && (
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900">Email Notifications</h3>
                <div className="mt-4 space-y-4">
                  <div className="flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        type="checkbox"
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label className="font-medium text-gray-700">
                        Integration Updates
                      </label>
                      <p className="text-gray-500">
                        Get notified when SaaS providers request integration with your hotel
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        type="checkbox"
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label className="font-medium text-gray-700">
                        PMS Status
                      </label>
                      <p className="text-gray-500">
                        Receive notifications about PMS connection status
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'security' && (
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900">Security Settings</h3>
                <div className="mt-4 space-y-4">
                  <div>
                    <button className="btn-primary">
                      Change Password
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}